module.exports = __webpack_public_path__ + "img/HTCC-AC02.62f7ac04.jpg";